import { ITeuteufGameInfo } from './interfaces';

const CDN_BASE_URL = 'https://teuteuf-dashboard-assets.pages.dev/';
const CDN_DATA_URL = `${CDN_BASE_URL}data/`;
const _cache: { [url: string]: string } = {};

async function fetchJSONFromCDN(endpoint: string, useCache = true) {
  if (useCache && _cache[endpoint]) {
    return _cache[endpoint];
  }

  // Fetch data, and cache it
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data: any = await fetch(CDN_DATA_URL + endpoint)
    .then((res) => res.json())
    .catch(() => null);
  _cache[endpoint] = data;
  return data;
}

export async function getGameInfo(): Promise<ITeuteufGameInfo> {
  // Example: https://teuteuf-dashboard-assets.pages.dev/data/teuteuf-games/games-info.json
  const data = await fetchJSONFromCDN('teuteuf-games/games-info.json');
  return data;
}

export function getGameIconUrl(gameName: string): string {
  // Example: https://teuteuf-dashboard-assets.pages.dev/data/teuteuf-games/icons/worldle.svg
  return `${CDN_DATA_URL}teuteuf-games/icons/${gameName
    .split(' ')
    .join('_')
    .toLowerCase()}.svg`;
}
